<template>
  <div data-v-249f9abc="" class="wrapper clearfix">
    <div data-v-1dc60391="" data-v-249f9abc="" class="content clearfix">
      <div data-v-1dc60391="" class="main">
        <div data-v-064cc9e2="" data-v-1dc60391="" >
          <h1 data-v-064cc9e2="">
            自助开票
          </h1>
          <!-- <h2 style="display: flex;justify-content: space-between"><span>请输入需要更改的客户编号</span><span style="color: #064A93">不记得编号？</span></h2>
                    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="20px" class="demo-ruleForm">
                        <el-form-item  prop="name">
                            <el-input v-model="ruleForm.name" placeholder="10位客户编号"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-input type="textarea" v-model="ruleForm.region" placeholder="客户名称"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-input style="width: 280px" v-model="ruleForm.yanzh" placeholder="验证码"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="submitForm('ruleForm')">下一步</el-button>
                        </el-form-item>
                    </el-form> -->
                    <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="个人" name="first">
                 <el-form
               :model="ruleForm"
               :rules="rules"
               ref="ruleForm"
               label-width="150px"
               class="demo-ruleForm"
             >
              <el-form-item label="发票抬头：" prop="name" class="cl_one">
                <el-input
                  v-model="ruleForm.name"
                  class="jianwidth"
                  placeholder="请输入发票抬头"
                ></el-input>
              </el-form-item>
              
              <el-form-item label="总金额：" prop="cost" >
                <el-input
                  v-model="ruleForm.cost"
                  class="jianwidth"
                  placeholder="请输入总金额"
                ></el-input>
              </el-form-item>
              <el-form-item label="开户行：" prop="num">
                <el-input
                  v-model="ruleForm.num"
                  class="jianwidth"
                  placeholder="填写开户行"
                ></el-input>
              </el-form-item>
              <el-form-item label="银行账号：" prop="kahao">
                <el-input
                  v-model="ruleForm.kahao"
                  class="jianwidth"
                  placeholder="填写银行账号"
                ></el-input>
              </el-form-item>
              <el-form-item label="地址及电话：" prop="num_new">
                <el-input
                  v-model="ruleForm.num_new"
                  class="jianwidth"
                  placeholder="填写地址及电话"
                ></el-input>
              </el-form-item>

              <el-form-item
                label="备注信息："
                prop="name_new"
                class="cl_one"
              >
                <el-input
                  v-model="ruleForm.name_new"
                  class="jianwidth"
                  placeholder="填写地址及电话"
                ></el-input>
              </el-form-item>
              <el-form-item label="电子邮箱：" 
              :rules="[
      { required: true, message: '请输入邮箱地址', trigger: 'blur' },
      { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
    ]"
              prop="name" class="cl_one">
                <el-input
                  v-model="ruleForm.name"
                  class="jianwidth"
                  placeholder="填写电子邮箱"
                ></el-input>
              </el-form-item>
              
              
              <el-form-item>
                <el-button type="primary" :plain="true" @click="submitForm('ruleForm')">提交</el-button>
                
              </el-form-item>
            </el-form>
            </el-tab-pane>
            <el-tab-pane label="企业" name="second" >
              <el-form
                :model="ruleForm_qi"
                :rules="rulesly"
                ref="ruleForm_qi"
                label-width="180px"
                class="demo-ruleForm"
              >
              <el-form-item label="发票抬头：" prop="name" class="cl_one">
                <el-input
                  v-model="ruleForm_qi.name"
                  class="jianwidth"
                  placeholder="请输入发票抬头"
                ></el-input>
              </el-form-item>
              <el-form-item label="税号：" prop="shuihao" >
                <el-input
                  v-model="ruleForm.shuihao"
                  class="jianwidth"
                  placeholder="请输入税号"
                ></el-input>
              </el-form-item>
              <el-form-item label="总金额：" prop="cost" >
                <el-input
                  v-model="ruleForm_qi.cost"
                  class="jianwidth"
                  placeholder="请输入总金额"
                ></el-input>
              </el-form-item>
              <el-form-item label="开户行：" prop="num">
                <el-input
                  v-model="ruleForm_qi.num"
                  class="jianwidth"
                  placeholder="填写开户行"
                ></el-input>
              </el-form-item>
              <el-form-item label="银行账号：" prop="kahao">
                <el-input
                  v-model="ruleForm_qi.kahao"
                  class="jianwidth"
                  placeholder="填写银行账号"
                ></el-input>
              </el-form-item>
              <el-form-item label="地址及电话：" prop="num_new">
                <el-input
                  v-model="ruleForm_qi.num_new"
                  class="jianwidth"
                  placeholder="填写地址及电话"
                ></el-input>
              </el-form-item>

              <el-form-item
                label="备注信息："
                prop="name_new"
                class="cl_one"
              >
                <el-input
                  v-model="ruleForm_qi.name_new"
                  class="jianwidth"
                  placeholder="填写地址及电话"
                ></el-input>
              </el-form-item>
              <el-form-item label="电子邮箱：" 
              :rules="[
      { required: true, message: '请输入邮箱地址', trigger: 'blur' },
      { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
    ]"
              prop="name" class="cl_one">
                <el-input
                  v-model="ruleForm_qi.name"
                  class="jianwidth"
                  placeholder="填写电子邮箱"
                ></el-input>
              </el-form-item>
                
                <el-form-item >
                  <el-button type="primary" :plain="true" @click="submitForm('ruleForm')">提交</el-button>
                 
                </el-form-item>
              </el-form>
            </el-tab-pane>
          </el-tabs>
          <div style="margin-bottom: 50px;">
            <h2 style="padding: 20px 20px 5px 20px">温馨提示:</h2>
          <h2 style="padding: 6px 20px;line-height: 145%">
            1.
            个人客户委托付款方可以与客户名称不一致，如持银行卡办理，委托付款方需与银行卡背面签名一致。
            <br />2. 个人客户： 该业务仅限委托付款人本人办理。
          </h2>
          </div>
          
        </div>
      </div>
      <businessAside />
    </div>
  </div>
</template>

<script>
import businessAside from "../../components/aside";
export default {
  data() {
    return {
      dialogImageUrl: "",
      dialogVisible: false,
      activeName: "first",
      fileList: "",
      textarea: "",
      value1: "",
      ruleForm: {
        cost: "",
        name: "",
        num: "",
        name_new: "",
        num_new: "",
        dizhi: "",
        region1: "",
        region2: "",
        region3: "",
        miaoshu: "",
        value: "",
        resource: "",
        region: "",
        yanzh: "",
      },
      ruleForm_qi: {
        cost: "",
        name: "",
        num: "",
        name_new: "",
        num_new: "",
        dizhi: "",
        region1: "",
        region2: "",
        region3: "",
        miaoshu: "",
        value: "",
        resource: "",
        region: "",
        yanzh: "",
      },
      // ruleForm: {
      //     name: '',
      //     region: '',
      //     yanzh:''
      // },
      rules: {
        // name: [
        //     { required: true, message: '请输入10位客户编号', trigger: 'blur' },
        //     { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        // ],
        // region: [
        //     { required: true, message: '请选择活动区域', trigger: 'change' }
        // ],
        name: [
          {
            required: true,
            message: "请输入原委托付款人姓名",
            trigger: "blur",
          },
          { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" },
        ],
        // num: [
        //   { required: true, message: "请输入开户行", trigger: "change" },
        // ],
        // name_new: [
        //   {
        //     required: true,
        //     message: "请输入新委托付款人姓名",
        //     trigger: "blur",
        //   },
        //   { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" },
        // ],
        // num_new: [
        //   { required: true, message: "请输入新客户手机号码", trigger: "blur" },
        //   { min: 11, max: 11, message: "11位字符", trigger: "blur" },
        // ],
        // miaoshu: [
        //   { required: true, message: "请上传产权证明", trigger: "change" },
        // ],
        // region1: [
        //   {
        //     required: true,
        //     message: "请上传身份证有人像的一面",
        //     trigger: "change",
        //   },
        // ],
        // region3: [
        //   {
        //     required: true,
        //     message: "请上传身份证有国徽的一面",
        //     trigger: "change",
        //   },
        // ],
        // cost: [
        //   { required: true, message: "请输入总金额", trigger: "change" },
        // ],
        // dizhi: [
        //   { required: true, message: "请输入身份证号", trigger: "change" },
        // ],
        // kahao: [
        //   { required: true, message: "请输入银行卡号", trigger: "change" },
        // ],
        // resource: [
        //   { required: true, message: "请选择用户类型", trigger: "change" },
        // ],
      },
      rulesly: {
        name: [
          {
            required: true,
            message: "请输入原委托付款人姓名",
            trigger: "blur",
          },
          { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" },
        ],
        shuihao: [{ required: true, message: "请输入税号", trigger: "blur" }],
        num_qi: [{ required: true, message: "请输入单位全称", trigger: "blur" }],
        jingbani_qi: [
          { required: true, message: "请输入联系人", trigger: "blur" },
          { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" },
        ],
        jblxfs_qi: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
          { min: 11, max: 11, message: "11位字符", trigger: "blur" },
        ],
        sfzhnum_qi:[
          { required: true, message: "请输入身份证号", trigger: "change" },
        ],
        chanquan_qi: [
          { required: true, message: "请上传产权证明", trigger: "change" },
        ],
        zjzm_qi: [
          {
            required: true,
            message: "请上传原单位营业执照",
            trigger: "change",
          },
        ],
        zjfm_qi: [
          {
            required: true,
            message: "请上传现单位营业执照",
            trigger: "change",
          },
        ],
        frontOfIDCard: [
            { required: true, message: '请上传身份证有人像的一面', trigger: 'change' }
        ],
        backOfIDCard: [
          { required: true, message: '请上传身份证有国徽的一面', trigger: 'change' }
        ],
        frontOfIDCard_jb: [
            { required: true, message: '请上传身份证有人像的一面', trigger: 'change' }
        ],
        backOfIDCard_jb: [
          { required: true, message: '请上传身份证有国徽的一面', trigger: 'change' }
        ],
      },
    };
  },
  watch: {
    // subType(n) {
    //     if ([0, 1, 2].indexOf(n) !== -1) {
    //         this.disabled = false
    //     } else {
    //         this.disabled = true
    //     }
    //     console.log(this.disabled)
    // },
    // isOk(n) {
    //     if (n) {
    //         this.disabled = false
    //     } else {
    //         this.disabled = true
    //     }
    //     console.log(this.disabled)
    // },
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleChange(file, fileList) {
      this.fileList = fileList.slice(-3);
    },
    submitForm() {
      this.$message({
          message: '提交成功,请勿重复此操作!',
          type: 'success'
        });
    },
    // submitForm(formName) {
    //     this.$refs[formName].validate((valid) => {
    //         if (valid) {
    //             alert('submit!');
    //         } else {
    //             console.log('error submit!!');
    //             return false;
    //         }
    //     });
    // },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // toRegret() {
    //     const BASE_PATH = window.location.href.split('#')[0]
    //     window.location.href = BASE_PATH + '#' + '/regret_pe'
    // },
  },
  components: {
    businessAside,
  },
};
</script>

<style scoped>
h2 {
  color: #8f8f8f;
  padding: 20px;
}
</style>
